import { createElement } from 'react';
import { toast } from 'sonner';
import { ToastContent } from '../ui/atom/toast-content';
import type { ToastVariant } from '@/shared-ui';

interface ShowToastOptions {
    title: string;
    description: string;
    variant: ToastVariant;
    duration?: number;
}

export function showToast(options: ShowToastOptions) {
    return toast.custom(
        (id) =>
            createElement(ToastContent, {
                title: options.title,
                description: options.description,
                variant: options.variant,
                onClose: () => toast.dismiss(id),
            }),
        {
            duration: options.duration,
        }
    );
}
